import {
  HOME_ENERGY_COST_ID,
  EV_ENERGY_COST_ID,
  GAS_ENERGY_COST_ID,
} from '../constants/';
import pattern from "patternomaly";


const rateComparisonChartData = ({
  rateTotals,
  labelHome,
  labelElectric,
  labelGasoline,
}) => {
  const isMobile = window.innerWidth < 768;
  return {
    datasets: [
      {
        label: labelHome,
        id: HOME_ENERGY_COST_ID,
        data: rateTotals.map((rateTotal) => rateTotal[HOME_ENERGY_COST_ID]),
        backgroundColor: '#00148C',
        barPercentage: 0.5,
        barThickness: isMobile ? 'flex' : 95,
        categoryPercentage: 1,
      },
      {
        label: labelElectric,
        id: EV_ENERGY_COST_ID,
        data: rateTotals.map((rateTotal) => rateTotal[EV_ENERGY_COST_ID]),
        backgroundColor:  pattern.draw("dot", "#00873F", "#000", 8),
        barPercentage: 0.5,
        barThickness: isMobile ? 'flex' : 95,
        categoryPercentage: 1,
      },
      {
        label: labelGasoline,
        id: GAS_ENERGY_COST_ID,
        data: rateTotals.map((rateTotal) => rateTotal[GAS_ENERGY_COST_ID]),
        backgroundColor: pattern.draw("diagonal-right-left", "#FFB45A", "#979797", 5),
        barPercentage: 0.5,
        barThickness: isMobile ? 'flex' : 95,
        categoryPercentage: 1,
      },
    ],
    labels: [...rateTotals.map((rate) => rate.title)],
    ids: [...rateTotals.map((rate) => rate.id)],
  };
};

export default rateComparisonChartData;
